import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { BreadcrumbsModule } from '@core/components/breadcrumbs/breadcrumbs.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { AbstractPane } from '../models/abstract-pane';

@Component({
  selector: 'app-bread-crumbs',
  templateUrl: './bread-crumbs.component.html',
  styleUrls: ['./bread-crumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/** @deprecated Use BreadcrumbsModule instead */
export class BreadCrumbsComponent extends AbstractPane {
  public hasContent() {
    return true;
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    /**
     * Так как панель не имеет динамического контента,
     * а всего лишь информационная - по умолчанию всегда отображается
     */
    this.isVisible = true;
  }
}

@NgModule({
  declarations: [BreadCrumbsComponent],
  imports: [CommonModule, SpinnersModule, BreadcrumbsModule],
  exports: [BreadCrumbsComponent],
})
class BreadCrumbsModule {}
